import logo from 'assets/Talo-Logo-White.webp';
import productMockup from 'assets/product-mockup.webp';
import Button from 'components/buttons/Button';
import LegitScriptSeal from 'components/core/legitscript-seal';
import { ROUTES } from 'config/route-configuration';

const Footer = () => {
  return (
    <footer className="w-full bg-[#1A3736] px-6 pb-10 pt-10 text-white rounded-t-3xl">
      <div className="mx-auto w-full overflow-hidden bg-[#1A3736]">
        <div className="flex flex-col gap-20 px-4 pb-8 md:flex-row md:items-center md:gap-20">
          <div className="md:w-1/2 space-y-8 text-left">
            <h2 className="font-mont text-[28px] font-black leading-tight text-white mt-5">
              Get your confidence and control back today
            </h2>
            <p className="text-sm text-white/80 leading-relaxed">
              Join thousands of men who trust Talo for fast, discreet ED treatment. Start your 5-minute assessment to
              get started.
            </p>
            <Button text="Get treatment" link={ROUTES.EDQUESTIONNAIRE} variant="secondary" />
          </div>
          <div className="md:w-1/2 flex justify-end">
            <img
              src={productMockup}
              alt="Talo product mockup"
              className="w-full rounded-2xl bg-gray-300 object-contain md:w-3/4"
              style={{ display: 'block' }}
            />
          </div>
        </div>

        <div className="flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:gap-12">
          <div className="md:w-1/4 space-y-3">
            <img src={logo} alt="Talo logo" className="h-10 w-auto" />
            <p className="text-sm text-white/70">&copy; {new Date().getFullYear()} Talo. All rights reserved.</p>
            <p className="text-sm text-white/70">Previously Dr. Andrews</p>
            <a
              href="https://www.pharmacyregulation.org/registers/pharmacist/2058682"
              className="block text-white/70 hover:text-white text-sm underline"
            >
              Superintendent Pharmacist: David Massie 2058682
            </a>
            <LegitScriptSeal className="inline-block" />
          </div>
          <div className="md:w-1/4 space-y-2">
            <p className="text-sm font-semibold text-white">Treatment</p>
            <a href={ROUTES.EDQUESTIONNAIRE} className="block text-sm text-white/80 hover:text-white">
              Get started
            </a>
            <a href={ROUTES.EDTREATMENT} className="block text-sm text-white/80 hover:text-white">
              ED treatment
            </a>
            <a href={ROUTES.WEIGHTLOSSTREATMENT} className="block text-sm text-white/80 hover:text-white">
              Weight loss
            </a>
          </div>
          <div className="md:w-1/4 space-y-2">
            <p className="text-sm font-semibold text-white">Support</p>
            <a href={ROUTES.TERMSOFUSE} className="block text-sm text-white/80 hover:text-white">
              Terms of Use
            </a>
            <a href={ROUTES.TERMSOFSUPPLY} className="block text-sm text-white/80 hover:text-white">
              Terms of Supply
            </a>
            <a href={ROUTES.PRIVACYPOLICY} className="block text-sm text-white/80 hover:text-white">
              Privacy policy
            </a>
          </div>
          <div className="md:w-1/4 space-y-2 text-sm text-white/80">
            <a href="mailto:support@jointalo.com" className="block hover:text-white font-bold">
              support@jointalo.com
            </a>
            <p>0333 220 0260</p>
            <p>17 Fieldhead Square</p>
            <p>Eastwood</p>
            <p>Glasgow</p>
            <p>G43 1HL</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
